import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from '@angular/router';
import { FeatureService } from '@shared/services/feature.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';

@Injectable()
export class FeatureGuard implements CanActivate {
  private readonly globalFeatures: any;
  constructor(
    private featureService: FeatureService,
    private router: Router,
    private runTimeConfigService: RunTimeConfigService
  ) {
    this.globalFeatures = this.runTimeConfigService.getConfig('featuresConfig').globalFeatures;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const matchedFeatureObj = this.globalFeatures.apps.find(o => o.routes.find(r => r.includes(state.url)));
      //   this.globalFeatures.apps.find(o =>
      //   o.routes.some(r => {
      //     return state.url.includes(r);
      //   })
      // ); // globalFeatures.apps.find(o => o.routes.find(r=>r.includes(state.url)));

      if (matchedFeatureObj) {
        if (!this.featureService.isFeatureEnabled(matchedFeatureObj)) {
          const navigationExtras: NavigationExtras = {
            state: {
              featureUnavailableError: true
            }
          };
          this.router.navigate(['error'], navigationExtras).then(r => {});
          reject();
        } else {
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });
  }
}
